import React from 'react';
import { render } from 'react-dom';
import ModalContext from '../ModalContext/ModalContext';

// eslint-disable-next-line import/prefer-default-export
export function createModalPromise(type, properties, id = 'temp-element') {
  const tempElement = document.createElement('div');
  tempElement.setAttribute('id', id);
  const dispose = () => {
    ModalContext.setOpenOrGlobal(false); // Trucco! La modale non viene "chiusa" ma distrutto il componente che la contiene.
    render(<div />, tempElement);
  }; // to destroy Confirm
  const confirmPromise = new Promise(() => { });
  // override then method
  confirmPromise.then = (resolve, reject) => {
    const onClose = properties.onClose ? () => {
      properties.onClose();
      dispose();
    } : dispose;
    render(React.createElement(type, {
      ...properties, onClose, onConfirm: resolve, onCancel: reject, resolve, reject,
    }), tempElement);
  };
  return confirmPromise;
}
